import React from 'react';
import { MessageCircle } from 'lucide-react';

/**
 * WhatsAppButton - Subtle floating WhatsApp contact button
 * Small, bottom-right, NO pulsing animation
 */
const WhatsAppButton = () => {
  const whatsappLink = "https://wa.me/917899275871";

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-12 h-12 bg-[#22D3A5] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 hover:bg-[#1FC799]"
      aria-label="Contact on WhatsApp"
      title="Chat on WhatsApp"
    >
      <MessageCircle size={24} className="text-white" />
    </a>
  );
};

export default WhatsAppButton;
